import { useFormContext } from '@sravni/cosago-react-library/lib/hooks';
import type { IFieldFactoryProps } from '@sravni/cosago-react-library/lib/types';
import type { FormEvent } from 'react';

import { Switch } from 'shared/ui/Switch';

import type { TPassportFormFields } from 'entities/creditForm';

export const ResidenceAddressIsRegistration: FC<IFieldFactoryProps> = (props) => {
  const { label } = props;
  const { watch, setValue, clearErrors } = useFormContext<TPassportFormFields>();
  const isSameAddresses = watch('residenceAddressIsRegistration');
  const registrationAddress = watch('registrationAddress');
  const registrationAddressFlat = watch('registrationAddressFlat');

  const handleChange = (event: FormEvent<HTMLInputElement>) => {
    // сначала переносим / очищаем данные в адресе проижвания и только потом включаем его отображение
    const isChecked = event.currentTarget.checked;
    clearErrors('residenceAddress');

    if (isChecked && registrationAddress) {
      setValue(
        'residenceAddress',
        {
          data: {
            ...registrationAddress.data,
          },
          value: registrationAddress.value,
          label: registrationAddress.label,
        } as TPassportFormFields['residenceAddress'],
        { shouldValidate: true },
      );
      setValue('residenceAddressFlat', registrationAddressFlat, { shouldValidate: true });
    } else {
      setValue('residenceAddressFlat', '', { shouldValidate: false });
      setValue('residenceAddress', null, { shouldValidate: false });
    }

    setValue('residenceAddressIsRegistration', event.currentTarget.checked);
  };

  return (
    <Switch
      checked={isSameAddresses}
      onChange={handleChange}
    >
      {label}
    </Switch>
  );
};
